<template>
  <div>
    <div class="banner">
      <canvas id="canvas" class="canvas" style="display: inline-block;"></canvas>
      <div class="login-area clearfix">
      <div class="container" style="position: absolute;top: 0; left: 0; right: 0;">
        <h2>{{ $t("message.title") }}</h2>
        <h6>{{ $t("message.banner") }}</h6>
        <!-- <a href="/Report">{{ $t("message.bannerButtonTxt") }}</a> -->
        <router-link to="/Report" class="blue-btn">{{ $t("message.bannerButtonTxt") }}</router-link>
      </div>
      </div>
    </div>
    <div class="container text-center">
      <div class="index-area vulnerability">
        <h2>{{ $t("message.vuln.title") }}</h2>
        <p v-html="$t('message.vuln.text')"></p>
        <img :src="vulnImg">
      </div>
    </div>
    <!-- <div class="index-area about text-center">
      <div class="container">
        <h2>{{ $t("message.about.title") }}</h2>
        <p v-html="$t('message.about.text')"></p>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      return {
        locale: localStorage.locale
      }
    },
    mounted: function () {
      function skyCanvas() {
          function t(t, i) {
              if (arguments.length < 2 && (i = t,
              t = 0),
              t > i) {
                  var s = i;
                  i = t,
                  t = s
              }
              return Math.floor(Math.random() * (i - t + 1)) + t
          }
          function i(t, i) {
              var s = Math.max(t, i)
                , a = Math.round(Math.sqrt(s * s + s * s));
              return a / 2
          }
          function s() {
              var t = new Image;
              t.src = "/static/img/star.jpg",
              t.onload = function() {
                  n.drawImage(t, 0, 0),
                  window.requestAnimationFrame(s)
              }
              ,
              n.drawImage(t, 0, 0);
              for (var i = 1, a = r.length; a > i; i++)
                  r[i].draw()
          }
          var a = document.getElementById("canvas")
            , n = a.getContext("2d")
            , o = a.width = $(".banner").width()
            , e = a.height = $(".banner").height()
            , r = []
            , c = 0
            , d = 300
            , l = document.createElement("canvas")
            , h = l.getContext("2d");
          l.width = 100,
          l.height = 100;
          var m = l.width / 2
            , f = h.createRadialGradient(m, m, 3, m, m, 26);
          f.addColorStop(.025, "#87c0f6"),
          f.addColorStop(.25, "#11417a"),
          f.addColorStop(1, "transparent"),
          h.fillStyle = f,
          h.beginPath(),
          h.arc(m, m, m, 0, 2 * Math.PI),
          h.fill();
          var u = function() {
              this.orbitRadius = t(i(o, e)),
              this.radius = t(60, this.orbitRadius) / 12,
              this.orbitX = o / 2,
              this.orbitY = e / 2,
              this.timePassed = t(0, d),
              this.speed = t(this.orbitRadius) / 9e5,
              this.alpha = t(2, 10) / 10,
              c++,
              r[c] = this
          };
          u.prototype.draw = function() {
              var i = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX
                , s = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY
                , a = t(10);
              1 === a && this.alpha > 0 ? this.alpha -= .05 : 2 === a && this.alpha < 1 && (this.alpha += .05),
              n.globalAlpha = this.alpha,
              n.drawImage(l, i - this.radius / 2, s - this.radius / 2, this.radius, this.radius),
              this.timePassed += this.speed
          }
          ;
          for (var p = 0; d > p; p++)
              new u;
          s()
      }
      skyCanvas();
    },
    computed: {
      vulnImg: function () {
        return this.$t('message.vuln.img')
      }
    }
  }
</script>
<style>
  .banner {  width: 100%;  height: 220px; background-image: url(/static/img/bg.jpg);  background-position: top center;  background-size: cover;  color: #fff;  text-align: center;  text-shadow: 0 0 3px rgba(0, 0, 0, .5); overflow: hidden;position: relative}
  .banner h2 {  font-size: 22px; opacity: .95;margin-bottom: 0;margin-top: 25px;}
  .banner h6 {  font-size: 14px; line-height: 1.4;  padding: 10px 0;  font-weight: normal;margin-top: 0 }
  .banner a {  padding: 6px 15px; border: 1px solid #fff;  border-radius: 3px;  color: #fff; text-decoration: none; font-size: 14px;  }


  .index-area {padding: 20px 0;}
  .index-area h2 {font-size: 22px;}
  .index-area p {font-weight: normal;  font-size: 14px;text-align: left;line-height: 1.6;}
  .about { background: #f2f2f2; }
  .vulnerability {background: #fff; }
  .vulnerability img{margin-top: 20px;}
  .about{margin-top: 20px;}
  .banner .blue-btn {
    background: #0071e3;
    border: 0;
    border-radius: 20px;
    padding: 10px 30px;
  }
  .banner .blue-btn:hover {
    background: #0077ED;
  }

  /* 平板，大于768 */
  @media (min-width: 768px) {
    .banner {height: 400px;}
    .banner h2 {  font-size: 40px;margin-top: 100px;}
    .banner h6 {  font-size: 28px;}
    .banner a{font-size: 18px;}
    .index-area h2 {font-size: 40px;margin-bottom: 20px;}
    .index-area p{font-size: 16px;}
  }
  /* 桌面显示器，大于992 */
  @media (min-width: 992px) {

  }
  /* 桌面显示器，大于1200 */
  @media (min-width: 1200px) {
    .banner {width: 100%; height: 600px; background-position: top center;  background-size: cover;  color: #fff; text-align: center; text-shadow: 0 0 3px rgba(0, 0, 0, .5);  }
    .banner h2 {font-size: 60px; opacity: .95;margin-top: 150px;}
    .banner h6 {font-size: 30px; line-height: 1.4; padding: 20px 50px; font-weight: normal;}
    .banner a {padding: 6px 15px; border: 1px solid #fff; border-radius: 3px; color: #fff; text-decoration: none; font-size: 18px;}
  }
</style>



// WEBPACK FOOTER //
// index.vue?06eedd70